/**
 * Client-side voice service — calls /api/voice (server-side Voxtral
 * proxy) and hands back a playable object URL. Caller owns the
 * HTMLAudioElement lifecycle (VoiceEngine), this just fetches bytes.
 */
export async function synthesizeSpeech(text: string, opts: { voiceId?: string } = {}): Promise<string> {
  const res = await fetch("/api/voice", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ text, voiceId: opts.voiceId, format: "mp3" }),
  });

  if (!res.ok) {
    throw new Error(`Voice request failed: ${res.status} ${await res.text()}`);
  }

  const blob = await res.blob();
  return URL.createObjectURL(blob);
}
